import jssCamelCase from 'jss-camel-case';
import jssCompose from 'jss-compose';
import jssDefaultUnit from 'jss-default-unit';
import jssExtend from 'jss-extend';
import jssGlobal from 'jss-global';
import jssNested from 'jss-nested';
import jssVendorPrefixer from 'jss-vendor-prefixer';
import { create } from 'jss';
export { createGenerateClassName, getDynamicStyles, SheetsManager, SheetsRegistry } from 'jss';
export var preset = {
  plugins: [jssGlobal(), jssExtend(), jssNested(), jssCompose(), jssCamelCase(), jssDefaultUnit(), jssVendorPrefixer()]
};
export default create(preset);